/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description uniqueListables
 */

export function uniqueListables<L extends { readonly uId: string | null | undefined }>(
  listables: null | undefined
): undefined
export function uniqueListables<L extends { readonly uId: string | null | undefined }>(
  listables: readonly L[]
): L[]
export function uniqueListables<L extends { readonly uId: string | null | undefined }>(
  listables: readonly L[] | null | undefined
): L[] | undefined
export function uniqueListables<L extends { readonly uId: string | null | undefined }>(
  listables: readonly L[] | null | undefined
) {
  if (!listables?.filter) {
    return undefined
  }
  const dict = new Map()
  return listables.filter((listable) => {
    if (listable?.uId != null) {
      if (dict.has(listable.uId)) {
        return false
      }
      dict.set(listable.uId, true)
      return true
    }
    return false
  })
}
